import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatStepperModule } from '@angular/material/stepper';
import { StepperComponent } from './stepper.component';

@NgModule({
  imports: [
    CommonModule,
    MatStepperModule
  ],
  declarations: [
    StepperComponent
  ],
  exports: [
    StepperComponent
  ]
})
export class StepperModule { }
